import type { IMarketplaceCategory, IMarketplaceCategoryDto } from "./IMarketplaceCategory";

export class MarketplaceCategory implements IMarketplaceCategory
{

    categoryId: string;
    name: string; 
    ordinal: number;
    categoryGroupName: string;
    offersCount: number;

    isAutomotive: boolean;
    isLifestyle: boolean;
    displayName: string;
    subCategories: IMarketplaceCategory[];
    
    public static Automotive = new MarketplaceCategory( {
        categoryId: 'automotive',
        name: 'My Car',
        ordinal: 0,
        categoryGroupName: 'Automotive',
        offersCount: 0,
    });

    constructor( model: IMarketplaceCategoryDto )
    {

        this.categoryId = model.categoryId;
        this.name = model.name;
        this.ordinal = model.ordinal;
        this.offersCount = model.offersCount;
        this.categoryGroupName = model.categoryGroupName;
        this.subCategories = [];
        this.isAutomotive = this.categoryGroupName.toLowerCase() == 'automotive';
        this.isLifestyle = this.isAutomotive == false;

        this.displayName = this.isAutomotive ? this.name : this.name
            .replaceAll( " & ", "<br/>&" )
            .replaceAll( " ", "<br/>" )
            .replaceAll( "<br/>&", "<br/>& " ); 

    }

    get hasOffers()
    {
        return this.offersCount > 0;
    }

    get hasSubCategories()
    {
        return this.subCategories.length > 0;
    }

}